import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MenuService } from './app.menu.service';
import { PrimeNG } from 'primeng/config';
import { AppComponent } from './app.component';
import { I18nUtilService } from './core/util/i18n-util.service';

@Component({
    selector: 'app-main',
    templateUrl: './app.main.component.html',
    standalone: false
})
export class AppMainComponent {
  overlayMenuActive: boolean;

  staticMenuDesktopInactive: boolean;

  staticMenuMobileActive: boolean;

  drawerMenuDesktopActive = true;

  menuClick: boolean;

  search = false;

  searchClick = false;

  userMenuClick: boolean;

  topbarUserMenuActive: boolean;

  notificationMenuClick: boolean;

  topbarNotificationMenuActive: boolean;

  languageMenuClick: boolean;

  topbarLanguageMenuActive: boolean;

  rightMenuClick: boolean;

  rightMenuActive: boolean;

  configActive: boolean;

  configClick: boolean;

  resetMenu: boolean;

  menuHoverActive = false;

  constructor(
    private menuService: MenuService,
    private primengConfig: PrimeNG,
    public app: AppComponent,
    private i18nUtil: I18nUtilService
  ) {
    this.i18nUtil.initialize();
  }

  onLayoutClick() {
    if (!this.searchClick) {
      this.search = false;
    }

    if (!this.userMenuClick) {
      this.topbarUserMenuActive = false;
    }

    if (!this.notificationMenuClick) {
      this.topbarNotificationMenuActive = false;
    }

    if (!this.languageMenuClick) {
      this.topbarLanguageMenuActive = false;
    }

    if (!this.rightMenuClick) {
      this.rightMenuActive = false;
    }

    if (!this.menuClick) {
      if (this.isSlim()) {
        this.menuService.reset();
      }

      if (this.overlayMenuActive || this.staticMenuMobileActive) {
        this.hideOverlayMenu();
      }

      this.menuHoverActive = false;
      this.unblockBodyScroll();
    }

    if (this.configActive && !this.configClick) {
      this.configActive = false;
    }

    this.searchClick = false;
    this.configClick = false;
    this.userMenuClick = false;
    this.rightMenuClick = false;
    this.notificationMenuClick = false;
    this.languageMenuClick = false;
    this.menuClick = false;
  }

  onMenuButtonClick(event) {
    this.menuClick = true;
    this.topbarUserMenuActive = false;
    this.topbarNotificationMenuActive = false;
    this.topbarLanguageMenuActive = false;
    this.rightMenuActive = false;

    if (this.isOverlay()) {
      this.overlayMenuActive = !this.overlayMenuActive;
    }

    if (this.isDesktop() && this.isDrawer()) {
      this.drawerMenuDesktopActive = !this.drawerMenuDesktopActive;
    } else if (this.isDesktop()) {
      this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
    } else {
      this.staticMenuMobileActive = !this.staticMenuMobileActive;
      if (this.staticMenuMobileActive) {
        this.blockBodyScroll();
      } else {
        this.unblockBodyScroll();
      }
    }

    event.preventDefault();
  }

  onSearchClick(event) {
    this.search = !this.search;
    this.searchClick = !this.searchClick;
  }

  onSearchHide(event) {
    this.search = false;
    this.searchClick = false;
  }

  onMenuClick($event) {
    this.menuClick = true;
    this.resetMenu = false;
  }

  onTopbarUserMenuButtonClick(event) {
    this.userMenuClick = true;
    this.topbarUserMenuActive = !this.topbarUserMenuActive;

    this.hideOverlayMenu();

    event.preventDefault();
  }

  onTopbarNotificationMenuButtonClick(event) {
    this.notificationMenuClick = true;
    this.topbarNotificationMenuActive = !this.topbarNotificationMenuActive;

    this.hideOverlayMenu();

    event.preventDefault();
  }

  onTopbarLanguageMenuButtonClick(event) {
    this.languageMenuClick = true;
    this.topbarLanguageMenuActive = !this.topbarLanguageMenuActive;

    this.hideOverlayMenu();

    event.preventDefault();
  }

  onRightMenuClick(event) {
    this.rightMenuClick = true;
    this.rightMenuActive = !this.rightMenuActive;

    this.hideOverlayMenu();

    event.preventDefault();
  }

  onRippleChange(event) {
    this.app.ripple = event.checked;
    this.primengConfig.ripple.set(event.checked);
  }

  onConfigClick(event) {
    this.configClick = true;
  }

  isSlim() {
    return this.app.menuMode === 'slim';
  }

  isOverlay() {
    return this.app.menuMode === 'overlay';
  }

  isDrawer() {
    return this.app.menuMode === 'drawer';
  }

  isDesktop() {
    return window.innerWidth > 991;
  }

  isMobile() {
    return window.innerWidth <= 991;
  }

  hideOverlayMenu() {
    this.overlayMenuActive = false;
    this.staticMenuMobileActive = false;
  }

  blockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.add('blocked-scroll');
    } else {
      document.body.className += ' blocked-scroll';
    }
  }

  unblockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.remove('blocked-scroll');
    } else {
      document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
        'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
  }
}
